import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'
import { ShiftBadge } from '../components/ShiftBadge'

export type ShiftReplacementCanceledProps = BaseNotificationItemProps & {
  userName: string
  shiftId: string
  shiftStartDate?: string
  shiftEndDate?: string
  inactivityTime?: string
  type: 'shift_replacement_cancelled'
}

export function ShiftReplacementCanceled({
  userName,
  shiftId,
  shiftStartDate,
  shiftEndDate,
  inactivityTime,
  ...props
}: ShiftReplacementCanceledProps) {
  return (
    <NotificationItem
      {...props}
      title='Replacement Attempt for Shift Canceled'
      descriptionAddon={
        <p className='text-sm text-gray-500'>
          After multiple attempts of replacing shift{' '}
          <ShiftBadge
            id={shiftId}
            startDate={shiftStartDate}
            endDate={shiftEndDate}
            inactivityTime={inactivityTime}
            timezonePreference={props.timezonePreference}
          />{' '}
          from {userName}, no mission specialists accepted the replacement open shift.
        </p>
      }
    />
  )
}
